/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Educational_Sciences26Inputs */

const en__field__enum_primarystudyinterest_study_educational_sciences26 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Educational_Sciences26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Educational Sciences`)
};

const de__field__enum_primarystudyinterest_study_educational_sciences26 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Educational_Sciences26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erziehungswissenschaft`)
};

/**
* | output |
* | --- |
* | "Educational Sciences" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Educational_Sciences26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_educational_sciences26 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Educational_Sciences26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Educational_Sciences26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_educational_sciences26(inputs)
	return de__field__enum_primarystudyinterest_study_educational_sciences26(inputs)
});
export { _field__enum_primarystudyinterest_study_educational_sciences26 as "_field__enum_primaryStudyInterest_STUDY_EDUCATIONAL_SCIENCES" }